import React, { useState } from "react";
import { ELightPath } from "../../../../Model/CaptureProfile";
import { CartesianCoordinate } from "../../../../Model/Coordinate";
import { FilterCubeCalibration } from "../../../../Model/ImagerCalibration";
import { getModuleState } from "../../../../redux/reducers/ModuleStateReducer";
import { useTypedSelector } from "../../../../redux/reducers/RootReducer";
import CommandPanel from "../../../CommandPanel/CommandPanel";
import CollapsiblePanel from "../../../Common/CollapsiblePanel";
import ServicingTable from "../../../Common/ServicingTable";
import ImageLeveling from "../../../Imager/ImageLeveling";
import OpticAndCameraControl from "../../../Imager/OpticAndCameraControl";
import ImagerManualControl from "../../../Imager/ImagerManualControl";

type Props = {
  imagerIdentifier: string;
  lightPath: ELightPath;
  backBtn: () => void;
  imagerIdentifiersWithFilterCubes: string[];
  filterCubeOffset: FilterCubeCalibration[];
  setFilterCubeOffset: (filterCubeOffset: FilterCubeCalibration[]) => void;
};

export default function FilterCubeOffset({
  imagerIdentifier,
  lightPath,
  filterCubeOffset,
  setFilterCubeOffset,
  backBtn,
}: Props) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const moduleState = useTypedSelector((state) =>
    getModuleState(state, imagerIdentifier)
  );
  const imagerState = moduleState.imager;

  if (imagerState == null) {
    throw new Error("Imager state is null");
  }

  const updateOffset = (coordinate: CartesianCoordinate) => {
    const newFilterCubeOffset = [...filterCubeOffset];
    newFilterCubeOffset[selectedIndex] = {
      ...filterCubeOffset[selectedIndex],
      offset: coordinate,
    };
    setFilterCubeOffset(newFilterCubeOffset);
  };

  const data = React.useMemo(
    () =>
      filterCubeOffset.map((filterCube, idx) => ({
        name: filterCube.name,
        id: idx.toString(),
        x: filterCube.offset.x,
        y: filterCube.offset.y,
        z: filterCube.offset.z,
        selected: idx === selectedIndex,
      })),
    [filterCubeOffset, selectedIndex]
  );

  return (
    <CommandPanel
      style={{
        overflowY: "auto",
        WebkitBoxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        MozBoxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
      }}
    >
      <CommandPanel.DarkBackArrowHeader
        title="FilterCube Offsets"
        onBackArrowClick={backBtn}
        style={{
          height: 60,
        }}
      />

      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <ServicingTable
          imagerIdentifier={imagerIdentifier}
          imagerState={imagerState}
          dropNumber={0}
          onDropNumberChanged={() => {}}
          maxDrop={0}
          data={data}
          onRowSelected={(row) => setSelectedIndex(Number.parseInt(row.id))}
          onRowUpdated={(row) =>
            updateOffset({
              x: row.x,
              y: row.y,
              z: row.z,
            })
          }
        />

        <ImagerManualControl
          wellLimitEnabled={false}
          imagerIdentifier={imagerIdentifier}
        />
      </div>
    </CommandPanel>
  );
}
